// Fuera de Vite (los tests corren con `node --test`) no existe import.meta.env: sin este fallback,
// importar cualquier modulo que use AppConfig tira TypeError antes de llegar al primer assert.
const env = import.meta.env || {};

export const AppConfig = {
  app: {
    name: env.VITE_APP_NAME || "Fénix Autogestión",
    version: env.VITE_APP_VERSION || "0.1.0",
    environment: env.VITE_APP_ENV || "development",
  },

  api: {
    useMock: env.VITE_USE_MOCK === "true",
    mockDelay: Number.parseInt(env.VITE_MOCK_DELAY) || 0,
    cacheEnabled: env.VITE_API_CACHE_ENABLED === "true",
    isLocal: env.VITE_API_LOCAL === "true",
    localUrl: env.VITE_API_LOCAL_URL || "http://localhost:5007/api/autogestion",
    baseUrl: env.VITE_API_BASE_URL || "http://localhost:5007/api/autogestion",
    timeout: Number.parseInt(env.VITE_API_TIMEOUT) || 10000,
    retryAttempts: Number.parseInt(env.VITE_API_RETRY_ATTEMPTS) || 3,
    // Cada cuanto se le pregunta al back si hay novedades (ver EstadoService).
    selloTTL: env.VITE_SELLO_TTL || "5m",
  },

  // Dos números distintos a propósito: siniestros tiene guardia, contacto es la oficina.
  contacto: {
    whatsappSiniestros: env.VITE_WA_SINIESTROS || "",
    whatsappContacto: env.VITE_WA_CONTACTO || "",
  },

  features: {
    debug: env.VITE_ENABLE_DEBUG === "true",
  },

  isDevelopment: () => AppConfig.app.environment === "development",
  isProduction: () => AppConfig.app.environment === "production",
};
